
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ViewPeriod } from '@/types/dashboard';

interface PeriodSelectorProps {
  value: ViewPeriod;
  onChange: (value: ViewPeriod) => void;
}

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  value,
  onChange
}) => {
  return (
    <div className="flex items-center space-x-2">
      <span className="text-sm text-muted-foreground mr-2">Período:</span>
      <Select
        value={value}
        onValueChange={(val) => onChange(val as ViewPeriod)}
      >
        <SelectTrigger className="w-[120px]">
          <SelectValue placeholder="Selecione" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="day">Dia</SelectItem>
          <SelectItem value="week">Semana</SelectItem>
          <SelectItem value="month">Mês</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default PeriodSelector;
